export const probablyExternal = (url) => /(http(s?)):\/\//i.test(url);
